import { TemplatePageProps } from './types'
import { DunkShotEntity } from './entity'
import Icon from 'images/games/dunk-shot/icon.png'
import Detail1 from 'images/games/dunk-shot/detail1.png'
import { CashPoolLink, EightBallStrikeLink, Pocket7GamesLink, PoolClashLink } from '../../components'
import { Pocket7GamesSwiper } from './pocket7games'

export const DunkShotDetail: TemplatePageProps = {
  entity: {
    ...DunkShotEntity,
    logo: Icon,
    title: (
      <>
        Dunk Shot: A Fast-Paced <strong>Basketball Game Online</strong>
      </>
    ),
    description: (
      <>
        Step into <strong>Dunk Shot</strong>, the ultimate <strong>basketball shooting game</strong>, available within
        the Pocket7Games app! This action-packed title lets you shoot, score, and challenge yourself with every tap. If
        you&#39;re into high-energy <strong>online basketball games</strong>, this one delivers nonstop excitement.
        Download the Pocket7Games app today and start aiming for victory!
      </>
    ),
  },
  swiper: Pocket7GamesSwiper,
  content: [
    {
      title: (
        <>
          How to Play This <strong>Free Basketball Game</strong>?
        </>
      ),
      description: (
        <>
          Mastering <strong>Dunk Shot</strong> is all about rhythm and precision. Tap the screen to bounce your ball
          higher and higher, keeping your eyes on the hoop. Once you’ve lined up the shot, stop tapping to go for the
          swish! With three balls and a three-minute timer, every move in this <strong>basketball game</strong> counts.
          Whether you&#39;re going for a clean shot or a dramatic dunk, this <strong>free basketball game</strong> keeps
          the pressure on. Perfect for fans of competitive <strong>basketball games</strong> who love testing their
          reflexes.
        </>
      ),
      image: Detail1,
    },
    {
      title: (
        <>
          Explore More Competitive <strong>Ball Games</strong> on Pocket7Games
        </>
      ),
      description: (
        <>
          Looking to raise your game? Dunk Shot is one of the most dynamic <strong>basketball games</strong> in the{' '}
          <Pocket7GamesLink>Pocket7Games</Pocket7GamesLink> lineup. Play for fun or step into skill-based matchups with
          real prizes on the line. As you level up, check out other exciting <strong>ball games</strong> like{' '}
          <PoolClashLink />, <EightBallStrikeLink /> or <CashPoolLink />. Head over to <Pocket7GamesLink /> and dive
          into a full collection of fast-paced, competitive online games today!
        </>
      ),
    },
  ],
} as TemplatePageProps
